/**
 * Helper para verificação de permissões
 */

/**
 * Verifica se o usuário tem uma permissão específica
 * @param {Object} store - Store do Vuex
 * @param {string} permissao - Nome da permissão a ser verificada
 * @returns {boolean} True se o usuário tem a permissão, false caso contrário
 */
export function usuarioTemPermissao(store, permissao) {
  if (!store || !store.state || !store.state.autenticacao) {
    return false;
  }

  const usuarioLogado = store.state.autenticacao.usuarioLogado;

  if (!usuarioLogado || !usuarioLogado.permissoes) {
    return false;
  }

  // Verifica nas permissões gmapi.roles
  const roles = usuarioLogado.permissoes.gmapi?.roles || [];

  // Verifica se a permissão está presente no array de roles
  return roles.includes(permissao);
}

/**
 * Verifica se o usuário tem permissão para acessar o Assistente IA
 * @param {Object} store - Store do Vuex
 * @returns {boolean} True se o usuário pode acessar a IA, false caso contrário
 */
export function usuarioTemPermissaoIA(store) {
  return usuarioTemPermissao(store, "vue-ia-visualizar");
}

/**
 * Verifica se o usuário tem permissão para visualizar todas as unidades.
 * Sem essa permissão, o usuário não pode selecionar "Todos" nem deixar a unidade em branco.
 * @param {Object} store - Store do Vuex
 * @returns {boolean} True se o usuário pode selecionar "Todos" no filtro de unidade
 */
export function usuarioTemPermissaoVisualizarTodasUnidades(store) {
  return usuarioTemPermissao(store, "visualizar_todas_unidades");
}
